import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {AcquisitionChannelState} from "./AcquisitionChannelState";
import {
	ACQUISITION_CHANNEL_CREATED,
	ACQUISITION_CHANNEL_FETCHED,
	ACQUISITION_CHANNEL_SORT_ORDER_UPDATED,
	ACQUISITION_CHANNEL_UPDATED
} from "../../action/acquisitionChannel/actionType";

const initState: AcquisitionChannelState = {
	acquisitionChannels: none
};

const reducer = handleActions({
	[ACQUISITION_CHANNEL_FETCHED]: (state: AcquisitionChannelState,
		action: Action<any>): AcquisitionChannelState => {
		return {...state, acquisitionChannels: option(action.payload.acquisitionChannels)}
	},
	[ACQUISITION_CHANNEL_CREATED]: (state: AcquisitionChannelState,
		action: Action<ACQUISITION_CHANNEL_CREATED>): AcquisitionChannelState => {
		return {
			...state,
			acquisitionChannels: option(state.acquisitionChannels.getOrElse([]).concat(action.payload.acquisitionChannel))
		}
	},
	[ACQUISITION_CHANNEL_UPDATED]: (state: AcquisitionChannelState,
		action: Action<ACQUISITION_CHANNEL_UPDATED>): AcquisitionChannelState => {
		const acquisitionChannels = state.acquisitionChannels.getOrElse([]).map(
			a => a.id == action.payload.acquisitionChannel.id ? action.payload.acquisitionChannel : a);
		return {...state, acquisitionChannels: option(acquisitionChannels)}
	},
	[ACQUISITION_CHANNEL_SORT_ORDER_UPDATED]: (state: AcquisitionChannelState,
		action: Action<ACQUISITION_CHANNEL_SORT_ORDER_UPDATED>): AcquisitionChannelState => {
		return {...state, acquisitionChannels: option(action.payload.acquisitionChannels)};
	}
}, initState);

export default reducer;